import type { Dictionary } from "@/lib/i18n/dictionaries";
import { fill } from "@/lib/i18n/context";

const TECHNICAL_RE =
  /DATABASE_URL|db:ensure|npm run|OpenAI key|\.env|ECONNREFUSED|Internal server|postgres|SSL|stack|at \w+\(|node_modules|TypeError|ReferenceError|ENOENT|EPERM/i;

export function looksTechnicalError(message: string | null | undefined): boolean {
  if (!message) return false;
  return TECHNICAL_RE.test(message);
}

/** Prefer stable API `code`, never show technical/dev messages. */
export function resolveApiError(
  t: Dictionary,
  data?: { error?: string; code?: string } | null,
  fallbackCode: keyof Dictionary["errors"] = "generic",
  vars?: Record<string, string | number>,
): string {
  const code = data?.code;
  if (code && code in t.errors) {
    return fill(t.errors[code as keyof Dictionary["errors"]], vars || {});
  }
  const msg = data?.error?.trim();
  if (msg && !looksTechnicalError(msg)) return msg;
  return fill(t.errors[fallbackCode], vars || {});
}
